module.exports = __webpack_public_path__ + "static/media/ic_commercial_inactive.5b462d7b.svg";